module.exports = __webpack_public_path__ + "static/media/robot.bab3bb94.svg";